import React from 'react';
import {Datagrid, DateField, List, Pagination, TextField, useTranslate} from 'react-admin';
import {LocalisationFilter} from "./d4loc_filter";


const LocationPagination = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100]}/>
export const LocationList = () => {
    const translate = useTranslate();

    return (
        <List
            empty={false}
            filters={<LocalisationFilter/>}
            sort={{field: 'modified', order: 'DESC'}}
            exporter={false}
            pagination={<LocationPagination/>}>
            <Datagrid rowClick="show"
                      bulkActionButtons={false}>
                <TextField
                    label={translate('resources.locations.fields.name')}
                    source="objName"
                />
                <TextField
                    label={translate('resources.locations.fields.type.one')}
                    source="objType"
                />
                <TextField
                    label={translate('resources.locations.fields.scope.one')}
                    source="objScope"
                />
                <DateField
                    label={translate('resources.locations.fields.created')}
                    source="created"
                    showTime
                />
                <DateField
                    label={translate('resources.locations.fields.modified')}
                    source="modified"
                    showTime
                />
            </Datagrid>
        </List>
    );
};
